/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Risk Modelling Platform API
 * The API for the risk modelling platform
 * OpenAPI spec version: 1.0
 */

export type AppStatewideMaxFuelsProjectAllOfType =
  (typeof AppStatewideMaxFuelsProjectAllOfType)[keyof typeof AppStatewideMaxFuelsProjectAllOfType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppStatewideMaxFuelsProjectAllOfType = {
  "statewide-maxfuels": "statewide-maxfuels",
} as const;
